// extracted by mini-css-extract-plugin
export default {"card":"live-telemetry-register-card_card__g5z6W","value":"live-telemetry-register-card_value__zzKAn"};